/*
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import messageUtil from 'utils/messageUtil'
import CountType from 'enums/CountType'
import { SocialWebStoryScopeWidget } from 'schemas/SocialWebStoryScopeWidgetSchema'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { useEmojiNameToDisplayMap } from 'hooks/useEmojiState'
import { WidgetId } from 'features/types'
import {
  SunburstFirstLevelData,
  SunburstSecondLevelData
} from 'components/visualization/Sunburst/types'
import SunburstChart from '../../../visualization/Sunburst'
import { convertToSunburstData } from './utils/convertToSunburstData'
import { SelectedInsight } from '../InsightModal/types'

interface StoryScopeProps {
  widgetId: WidgetId
  levelOneInsights: string[]
  onClick: (insightDataArray: SelectedInsight[]) => void
}

const StoryScope = ({ widgetId, levelOneInsights, onClick }: StoryScopeProps) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebStoryScopeWidget>(widgetId)
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const emojiNameToDisplayMap = useEmojiNameToDisplayMap()
  const handleClick = ({ group }: { group: SunburstFirstLevelData | SunburstSecondLevelData }) => {
    const isLevelOneGroup = 'groups' in group
    if (isLevelOneGroup) {
      onClick([group.data])
    } else {
      onClick([{ ...group.data, levelOneFilter: group.firstLevel }])
    }
  }

  const sunburstData = convertToSunburstData(
    widgetData,
    widgetSetting,
    levelOneInsights,
    emojiNameToDisplayMap
  )

  const unit = messageUtil.countType(CountType.MENTIONS).toLowerCase()

  return <SunburstChart data={sunburstData} unit={unit} onClick={handleClick} />
}

export default StoryScope
